import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web-app/src/components/Toast/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BugsnagErrorBoundary"] */ "/app/apps/web-app/src/lib/_utils/bugsnag.ts");
;
import(/* webpackMode: "eager", webpackExports: ["EventsProvider"] */ "/app/apps/web-app/src/providers/EventsProvider/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web-app/src/style/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-translate/lib/esm/AppDirI18nProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Anuphan\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"adjustFontFallback\":false,\"variable\":\"--font-anuphan\"}],\"variableName\":\"anuphan\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Darker_Grotesque\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"adjustFontFallback\":false,\"variable\":\"--font-darker-grotesque\"}],\"variableName\":\"darker_grotesque\"}");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/app/node_modules/nuqs/dist/adapters/next/app.js");
